import type { HttpClient } from '@shared/http/http-client';
import type {
  IDeliveryNoteRepository,
  DeliveryNoteListQuery,
} from '@domain/data-contracts/delivery-note-repository.interface';
import type { DeliveryNote } from '@domain/models/delivery-note.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapDeliveryNoteDto,
  mapPaged,
  type DeliveryNoteDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/delivery-notes';

export class DeliveryNoteRepository implements IDeliveryNoteRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: DeliveryNoteListQuery): Promise<PagedResult<DeliveryNote>> {
    const response = await this.http.get<PagedDto<DeliveryNoteDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapDeliveryNoteDto);
  }
}

function pruneParams(query: DeliveryNoteListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.status) { out.status = query.status; }
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
